import React from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import UIButton from "../../UI/Button/Button";
import { styleType } from "../../../Constants/StyleType";

function CSVExport(props) {

    const convertJsonToCsv = () => {
        if (props.data.length === 0) {
            return '';
        }

        const headers = props.fileHeaders.join(',') + `\n`;
        const rows = props.data.map((row) => {
            return props.objectKeys.map((field) => row[field] || '').join(',');
        }).join('\n');

        return headers + rows;
    }

    const downloadCSV = () => {
        const csvData = convertJsonToCsv();

        if (csvData === '') {
            toast.warning("No data for exporting");
        } else {
            const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.setAttribute('download', `${props.fileTitle}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    return (
        <UIButton onClick={downloadCSV} buttonText={props.buttonText} styleType={styleType.FADEBLACK} additionalClass={"w-100"}/>
    )
}

CSVExport.propTypes = {
    fileHeaders: PropTypes.arrayOf(PropTypes.string),
    objectKeys: PropTypes.arrayOf(PropTypes.string),
    data: PropTypes.arrayOf(PropTypes.object),
    buttonText: PropTypes.string,
    fileTitle: PropTypes.string
}

export default CSVExport;